import React, { useEffect, useState, useCallback } from 'react'
import useApp from 'hooks/useApp'
import { useNavigate } from 'react-router-dom'
import { Box } from 'components'
import styles from 'views/life/index.module.css'
import { BellIcon, SettingIcon } from 'components/HeaderComponents'

const Life = () => {

	const App = useApp()
	const navigate = useNavigate();

	useEffect(() => {
		console.log("여기왔나???");
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <><BellIcon /><SettingIcon /></>,
			type: "transparent"
		})

		App.setShowNav(true)
		App.setMainClass("mydata pt_0")

	}, [])

	const onRouterGov = useCallback(() => navigate("/life/grantIntro"), []);

	return (
		<div className="page">
			<div className="padding pt_20">
				<h2>라이프</h2>

				{/* 조회내역이 없는 경우 배너 */}
				<Box className={`${styles["life-banner"]} mt_30 pb_60`} onClick={onRouterGov}>
					<p>
						내가 받을 수 있는<br /><strong>정부지원금</strong>은<br />얼마일까?
					</p>
					<div className={`${styles["more-btn"]} mt_25`}>More <i className="icon icon_btn_arrow_gray ml_5" /></div>
					<div className={styles["circle-bg"]} />
					<div className={styles["life-object"]} />
				</Box>

				{/* 조회내역이 있는 경우 배너 */}
				<Box className={`${styles["life-banner"]} mt_30 pb_60`}>
					<p>
						김모니님에게<br />100% 맞는 지원금<br /><strong className={styles.count}>50</strong> 건
					</p>
					<div className={`${styles["more-btn"]} mt_25`}>More <i className="icon icon_btn_arrow_gray ml_5" /></div>
					<div className={styles["circle-bg"]} />
					<div className={styles["life-object"]} />
				</Box>

				{/* 조회내역이 없는 경우 메뉴 리스트 */}
				<div className={`${styles["life-menu"]} mt_40`}>
					<ul className="my-menu">
						<li>
							<div className="box">
								<span>커리어</span>
								<i className="icon icon_menu icon_menu_13" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>패밀리</span>
								<i className="icon icon_menu icon_menu_14" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>내차보기</span>
								<i className="icon icon_menu icon_menu_15" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>내집보기</span>
								<i className="icon icon_menu icon_menu_16" />
							</div>
						</li>
					</ul>
				</div>

				{/* 조회내역이 있는 경우 메뉴 리스트 */}
				<div className={`${styles["life-menu"]} mt_40`}>
					<ul className="my-menu">
						<li>
							<div className="box">
								<span>커리어</span>
								<div className={`${styles.result} mt_10`}><span>1년 6개월</span></div>
								<p className={styles.info}>재직중</p>
								<i className="icon icon_menu icon_menu_13" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>패밀리</span>
								<div className={`${styles.result} mt_10`}><span>5명</span></div>
								<p className={styles.info}>서울시 영등포구</p>
								<i className="icon icon_menu icon_menu_14" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>내차보기</span>
								<div className={`${styles.result} mt_10`}><span>2대</span></div>
								<p className={styles.info}>1억 5,000만원</p>
								<i className="icon icon_menu icon_menu_15" />
							</div>
						</li>
						<li>
							<div className="box">
								<span>내집보기</span>
								<div className={`${styles.result} mt_10`}><span>2채</span></div>
								<p className={styles.info}>20억 5,000만원</p>
								<i className="icon icon_menu icon_menu_16" />
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div className={`${styles["scroll-banner"]} no-scroll pb_30 mt_10`}>
				<div className="banner-wrap">
					<Box>
						<p>회사조회</p>
						<span>궁금한 회사가 있다면<br />지금 바로 확인!</span>
						<span className="box-deco" />
						<i className="icon icon_menu icon_menu_20" />
					</Box>
					<Box>
						<p>학교조회</p>
						<span>어린이집부터 초・중・고<br />학교를 조회해보세요.</span>
						<span className="box-deco" />
						<i className="icon icon_menu icon_menu_18" />
					</Box>
					<Box>
						<p>여행정보조회</p>
						<span>한국관광공사가 인증한<br />숙박부터 맛집까지!</span>
						<span className="box-deco" />
						<i className="icon icon_menu icon_menu_19" />
					</Box>
				</div>
			</div>
		</div>
	)
}

export default Life